import(/* webpackMode: "eager" */ "/vercel/path0/apps/bonded-diamond/app/error.tsx");
